export enum ItemTypeEnum {
  Physical = 'physical',
  Digital = 'digital'
}
